module.exports = __webpack_public_path__ + "static/sec3-ae30082ae2fde25c479314207a0f78d7.png";